type PropTypes = {
  className?: string
};

const FilledCrossIcon = ({ className }: PropTypes) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="20"
        height="20"
        fill="white"
        fillOpacity={0.01}
        style={{ mixBlendMode: 'multiply' }}
      />
      <path d="M10 1.25C5.1875 1.25 1.25 5.1875 1.25 10C1.25 14.8125 5.1875 18.75 10 18.75C14.8125 18.75 18.75 14.8125 18.75 10C18.75 5.1875 14.8125 1.25 10 1.25ZM13.375 14.375L10 11L6.625 14.375L5.625 13.375L9 10L5.625 6.625L6.625 5.625L10 9L13.375 5.625L14.375 6.625L11 10L14.375 13.375L13.375 14.375Z" fill="#EF4444" />
    </svg>
  )
}

export default FilledCrossIcon
